var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  ref: "query",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.query,
                    "label-position": "right",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "订单号", clearable: "" },
                        model: {
                          value: _vm.query.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "orderNo", $$v)
                          },
                          expression: "query.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "第三方订单号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "第三方订单号", clearable: "" },
                        model: {
                          value: _vm.query.outTradeNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "outTradeNo", $$v)
                          },
                          expression: "query.outTradeNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "全部", clearable: "" },
                          model: {
                            value: _vm.query.orderStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "orderStatus", $$v)
                            },
                            expression: "query.orderStatus",
                          },
                        },
                        _vm._l(_vm.orderStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "姓名 / 手机号", clearable: "" },
                        model: {
                          value: _vm.query.receiverKeyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "receiverKeyword", $$v)
                          },
                          expression: "query.receiverKeyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.storeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "storeType", $$v)
                            },
                            expression: "query.storeType",
                          },
                        },
                        _vm._l(_vm.storeTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.value, value: item.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("\n              查询\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.exportLoading,
                          },
                          on: { click: _vm.exportOrders },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.exportLoading ? "导出中..." : "订单导出"
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("\n              重置\n            ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "list",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单号", "min-width": "190" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "outTradeNo",
                  label: "第三方订单号",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "店铺名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeTypeName",
                  label: "店铺类型",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatusName",
                  label: "订单状态",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(
                                scope.row.orderStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.orderStatusName) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryStatusName",
                  label: "快递状态",
                  width: "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getDeliveryStatusType(
                                scope.row.deliveryStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.deliveryStatusName) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "quantity", label: "商品数量", width: "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "totalAmount", label: "订单金额", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n              " +
                            _vm._s(scope.row.totalAmount + " ¥") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "payTime", label: "支付时间", width: "160" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "receiverName", label: "收货人", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "receiverPhone",
                  label: "联系电话",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "receiverDetailAddr",
                  label: "收货地址",
                  "min-width": "200",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "shipmentsTime",
                  label: "发货时间",
                  width: "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "receiveTime", label: "签收时间", width: "160" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryCompany",
                  label: "快递公司",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryNo",
                  label: "快递单号",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "130", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleView(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n              详情\n            ")]
                        ),
                        _vm._v(" "),
                        scope.row.orderStatus == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm._refund(scope.row)
                                  },
                                },
                              },
                              [_vm._v("退款")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [2, 3, 4, 5, 16].includes(scope.row.orderStatus)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["merchant:order:to:shipment"],
                                    expression:
                                      "['merchant:order:to:shipment']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.sendOrder(scope.row.orderNo)
                                  },
                                },
                              },
                              [_vm._v("订单发货")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [1, 2].includes(scope.row.orderStatus)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["merchant:order:update:receive"],
                                    expression:
                                      "['merchant:order:update:receive']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateReceive(scope.row.orderNo)
                                  },
                                },
                              },
                              [_vm._v("修改地址")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 50, 100, 200],
                  "page-size": _vm.query.limit,
                  "current-page": _vm.query.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrderSend", {
        ref: "OrderSendRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("ChangeReceive", {
        ref: "ChangeReceiveRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("OrderDetail", { ref: "OrderDetailRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }